export const cacheChromeRequest = {
    get: async (id, cache) => {
        if (cache) {
            const key = "cacheRequest-" + id;
            const cachedData = (await chrome.storage.local.get(key))[key];
            if (cachedData) {
                const hours = typeof cache === "number" ? cache : 24;
                const { requestDate, value } = cachedData;
                if (requestDate > Date.now() - hours * 3600000) {
                    return value;
                }
            }
        }
        return null;
    },
    set: async (id, value) => {
        const data = {
            value,
            id,
            requestDate: Date.now(),
        };
        const key = "cacheRequest-" + id;
        await chrome.storage.local.set({ [key]: data });
    },
};
